var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.deferredPrompt && _vm.firstPopup() && !_vm.neverPopup()
      ? _c("div", { staticClass: "popup-app-install-rest" })
      : _vm._e(),
    _vm.deferredPrompt && !_vm.neverPopup()
      ? _c(
          "div",
          {
            class: _vm.firstPopup()
              ? "popup-app-install-first"
              : _vm.checkIfMobileByUA()
              ? "popup-app-install-mobile"
              : "popup-app-install"
          },
          [
            _vm.firstPopup()
              ? _c("img", {
                  staticClass: "logo-app-install",
                  attrs: {
                    src: require("../../../public/img/icons/android-chrome-512x512.png"),
                    alt: ""
                  }
                })
              : !_vm.checkIfMobileByUA()
              ? _c("img", {
                  staticClass: "logo-app-install",
                  attrs: { src: require("../../assets/img/logo_white.png") }
                })
              : _vm._e(),
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.checkIfMobileByUA()
                    ? "Installer l'application ?"
                    : "Vous pouvez directement installer un raccourci de cette application sur votre bureau."
                ) +
                "\n    "
            ),
            _c("div", { staticClass: "buttons-app-install" }, [
              _c(
                "button",
                {
                  staticClass: "button-app-install",
                  attrs: { text: "" },
                  on: { click: _vm.install }
                },
                [_vm._v("\n        Ajouter\n      ")]
              ),
              _c(
                "button",
                {
                  staticClass: "button-app-install button-app-install-none",
                  attrs: { text: "" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v("\n        Non merci\n      ")]
              )
            ]),
            _c(
              "svg",
              {
                staticClass: "close-app-install",
                staticStyle: { "enable-background": "new 0 0 24 24" },
                attrs: {
                  version: "1.1",
                  viewBox: "0 0 24 24",
                  "xml:space": "preserve",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                },
                on: { click: _vm.closePopup }
              },
              [
                _c("g", { attrs: { id: "grid_system" } }),
                _c("g", { attrs: { id: "_icons" } }, [
                  _c("path", {
                    attrs: {
                      fill: "white",
                      d:
                        "M5.3,18.7C5.5,18.9,5.7,19,6,19s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3   c0.4-0.4,0.4-1,0-1.4L13.4,12l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L6.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4   l5.3,5.3l-5.3,5.3C4.9,17.7,4.9,18.3,5.3,18.7z"
                    }
                  })
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }